// src/store/slices/serviceSlice.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createGenericSlice } from './genericSliceFactory';
import { apiMethods } from '../../services/api';
import type { Service, ApiResponse } from '@/types';

const serviceSlice = createGenericSlice<Service>({
    name: 'services',
    endpoint: '/services',
});

export const {
    setCurrentItem: setCurrentService,
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = serviceSlice.actions;

export const {
    fetchActive: fetchActiveServices,
    fetchBySlug: fetchServiceBySlug,
} = serviceSlice.thunks;

export default serviceSlice.reducer;
